import { Component } from '@angular/core';

@Component({
  selector: 'i-play',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 115 120" fill="none">
      <path
        d="M114.008 60.0379C114.008 54.7661 112.143 49.4086 108.093 45.4226C102.093 39.5079 90.0703 28.8786 72.0048 18.4636C53.9393 8.04865 38.724 2.92687 30.6235 0.69815C25.1374 -0.823381 19.5656 0.248121 15.001 2.88401C10.4364 5.5199 6.72902 9.80591 5.31464 15.3134C3.19307 23.4568 0 39.1865 0 60.0379C0 79.6892 2.31444 94.4545 4.00741 102.662C5.31464 108.941 9.38635 113.956 14.5938 116.956C19.437 119.742 25.3303 120.878 31.1378 119.249C39.3669 116.935 54.3251 111.834 72.0263 101.612C90.0918 91.1971 102.114 80.5678 108.114 74.6531C112.165 70.6671 114.029 65.3096 114.029 60.0379H114.008Z"
        fill="currentColor"
      />
    </svg>
  `,
  host: {
    class: 'grid place-items-center',
  },
})
export class IconPlay {}
